export const EquationCardVariable = () =>{
    return(
        <div className="container">
            <p>数式エディタのカードの対象カードパラメータを指定します（指定しない場合はカードの数をカウントします）</p>
            <img src={`${process.env.PUBLIC_URL}/equation_card_variable.png`}></img>
            <p>図の例ではカウントするのが攻撃力を示します</p>
            </div>
    )
}
